import axios from 'axios';


  async function uploadFile(endpoint,file, data) {
    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('metadata', JSON.stringify(data));
  
      // Enviar la solicitud POST
      const response = await axios.post(endpoint, formData, {
        headers: {
          'Content-Type': 'multipart/form-data', // Axios lo ajusta automáticamente en la mayoría de los casos
        },
      });
      console.log(response);
      if(response.status == 200){
        return { success: true};
      }
      else{
        return { success: false, error: response.data.message };
      }
    } catch (err) {
      return { success: false, error: err.message };
    }
  }

function createService(apiUrl) {
    if (!apiUrl) {
        throw new Error("El URL de la API es requerido para inicializar el servicio.");
    }


    return {
        async createBlockBlobFromBrowserFile(containerName, blobName, file, callback) {
            if (!containerName || !blobName || !file || !callback) {
                callback(new Error("Todos los parámetros son necesarios."), null);
                return;
            }

            
            const result = await uploadFile(`${apiUrl}${containerName}/${blobName}`,file, {});
            
            if (result.success) {
                callback(null, { name: blobName });
            } else {
                callback(new Error(result.error), null);
            }
        },
    };
}

export default {
    createService,
};